/**
 *  Return width of element without padding and border
 *
 * @param {HTMLElement} element - html element whose width is to be calculated
 * @returns {number} - width
 */
const getWidthWithoutPadding = element => {
    if (!element) return 0;

    const computedStyle = getComputedStyle(element);
    const paddingLeft = parseFloat(computedStyle.paddingLeft);
    const paddingRight = parseFloat(computedStyle.paddingRight);
    const borderWidth = parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);

    return element.offsetWidth - (paddingLeft + paddingRight + borderWidth);
};

export default getWidthWithoutPadding;
